/**
 * Before the visit (2026-11-03; T0, dark). Mirrors GET /api/v1/manifest-intake/previsit and /previsit/:facilityId
 * (services/manifest/previsitWorklist.js). Read-only: there is no write call here.
 *
 * Its own file on purpose: manifestApi.ts is another builder's surface.
 */
import { apiRequest } from '../../services/api';

const BASE = '/manifest-intake';

export type PrevisitWhy = 'NEW_REFERRAL' | 'ANNUAL_DUE' | 'MCD_ISSUE';
export type PrevisitCounts = Record<PrevisitWhy, number>;
/** Residents counted, not listed: an audiogram in the last 365 days kept a new referral or Medicaid issue off, enrolled, or no reason to look. */
export type PrevisitExcluded = { recent_audiogram: number; enrolled: number; other: number };

export type PrevisitBuilding = {
  facility_id: string;
  facility_name: string | null;
  /** The earliest PLANNED or CONFIRMED plan in the next 14 days (YYYY-MM-DD, Eastern). */
  next_visit: string;
  state: 'PLANNED' | 'CONFIRMED';
  provider_employee_id: string | null;
  provider_name: string | null;
  listed: number;
  counts: PrevisitCounts;
  excluded: PrevisitExcluded;
};

export type PrevisitList = { today: string; window_days: number; items: PrevisitBuilding[] };

export type PrevisitResident = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  status: string | null;
  why: PrevisitWhy[];
  testing_status: string | null;
  testing_status_values: string[];
  testing_status_source: 'COUNSELEAR' | 'MONDAY';
  liability_cents: number | null;
  liability_status: string | null;
  /** The day the annual review falls due (12 months after the CounselEAR TWL date), or Monday's annual date when CounselEAR has none. */
  annual_date: string | null;
  annual_basis: 'COUNSELEAR_TWL_DATE' | 'MONDAY_FALLBACK';
  annual_date_label: string;
  /** Presence only, never the Medicaid number or the SSN. */
  has_medicaid_number: boolean;
  has_ssn: boolean;
  /** A source-dated audiogram within the last 365 days (the TWL tag plays no part). */
  audiogram_in_12_months: boolean;
};

export type PrevisitBuildingDetail = PrevisitBuilding & { today: string; residents: PrevisitResident[] };

export const previsitApi = {
  list: () => apiRequest<PrevisitList>('GET', `${BASE}/previsit`),
  building: (facilityId: string) => apiRequest<PrevisitBuildingDetail>('GET', `${BASE}/previsit/${encodeURIComponent(facilityId)}`),
};
